type GMapsModule = typeof import('gmaps').default;

let gmapsPromise: Promise<GMapsModule> | null = null;

const waitForGoogleMaps = (timeoutMs = 10_000): Promise<void> =>
  new Promise((resolve, reject) => {
    if (window.google?.maps) return resolve();
    const started = Date.now();
    const id = window.setInterval(() => {
      if (window.google?.maps) {
        window.clearInterval(id);
        resolve();
      } else if (Date.now() - started > timeoutMs) {
        window.clearInterval(id);
        reject(new Error('Google Maps JS API failed to load within 10s'));
      }
    }, 50);
  });

export const loadGMaps = (): Promise<GMapsModule> => {
  gmapsPromise ??= waitForGoogleMaps().then(async () => (await import('gmaps')).default);
  return gmapsPromise;
};
